import React from 'react';
import { LocalPopup } from 'js/components/common/Popup';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

import { Layout } from '../Layout';
import { getRootClassNames } from '../../helpers';

import style from './PagePopup.scss';

export const PagePopup = ({ page }) => {
    const { isShowAsModal = false } = page;
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();
    const { popupWidth, popupWidthUnit, hidePopUpTitle, title, rootClassNames } = page;

    return (
        <LocalPopup
            isModal={isShowAsModal}
            onClose={navigateToPopupBackgroundPage}
            title={hidePopUpTitle ? undefined : title}
            style={{ width: `${popupWidth}${popupWidthUnit}` }}
            className={`${style.container} ${getRootClassNames(rootClassNames).join(' ')}`}
        >
            <Layout page={page} isPageInPopup />
        </LocalPopup>
    );
};
